import {
  createRootRoute,
  HeadContent,
  Outlet,
  useNavigate,
  useRouterState,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Nav } from "@/components/Nav.tsx";
import { Chat } from "@/components/Chat.tsx";
import { styled } from "@linaria/react";
import SplitView from "@/components/layout/SplitView.tsx";
import { useEffect } from "react";
import { toast } from "sonner";
import { PRODUCTION } from "@/constants/settings.ts" with { types: "comptime" };

const PageWrapper = styled.main`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;

  //@container style(--small-height: 1) {
  //  height: 100%;
  //}
`;

const OutletWrapper = styled.div`
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  height: 100%;
`;

const devtools = !PRODUCTION && <TanStackRouterDevtools />;

const RootLayout = () => {
  const location = useRouterState({ select: (s) => s.location });
  const path = location.href;

  if (path.includes("/auth/")) {
    return (
      <>
        <HeadContent />
        <Outlet />
      </>
    );
  }

  return (
    <>
      <HeadContent />
      <Nav />
      <PageWrapper>
        <SplitView>
          <OutletWrapper>
            <Outlet />
          </OutletWrapper>
          <Chat />
        </SplitView>
      </PageWrapper>

      {devtools}
    </>
  );
};

const NotFoundLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.info("Page not found, redirecting to the home page.");
    navigate({ to: "/" }).catch((e: Error) => {
      console.error("Could not redirect", e);
      window.location.assign("/");
    });
  }, [navigate]);

  return (
    <div>
      <h1>404 - Not Found</h1>
      <p>The requested page could not be found.</p>
    </div>
  );
};

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundLayout,
});
